import { Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../providers/auth.service';
import { SidebarService } from '../providers/sidebar.service';
import { CommonModule } from '@angular/common';
import { DbService } from '../providers/db.service';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CategoryInterface, PeriodsInterface, TransactionsInterface } from '../interfaces';

@Component({
  selector: 'app-transactions',
  standalone: true,
  imports: [TranslocoDirective, CommonModule, FormsModule],
  templateUrl: './transactions.component.html',
  styleUrl: './transactions.component.css'
})
export class TransactionsComponent implements OnInit {
  transactions = [];
  selectedTrans: TransactionsInterface[] = [];
  selectedTransIndex = 99999999999;
  totals = {
    total: 0,
    ultimateTotal: 0
  };
  searchObject = {
    category: '',
    period: '',
    amountFrom: '',
    amountTo: '',
  };
  showSpinner = true;
  transactionsView = 'grid';
  catsArray: CategoryInterface[] = [];
  periodsArray: PeriodsInterface[] = [];
  periodsToDisplay = [];
  periodsToDisplayIndex = 0;
  periodDisplay = 'start'
  paginationSize = 0;
  currentPeriod = 0;
  selectedPeriod = 0;
  firstPage = true;
  lastPage = false;
  searchColumn = 'amount'
  searchFlag = false;
  searchPanel = false;
  availableSearchColumns = ['category', 'amount'] //'where'
  searchPhraseModel = { phrase: '' }

  public db = inject(DbService);
  public auth = inject(AuthService);
  private translocoService = inject(TranslocoService);
  private toastr = inject(ToastrService);
  public sb = inject(SidebarService);
  showToast(toastType: string, title: string, content?: string) {
    const varTimeOut = 3000;
    const varProgressBar = true;
    const varPositionClass = 'toast-top-center';
    if (toastType === 'success') {
      this.toastr.success(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else if (toastType === 'info') {
      this.toastr.info(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else {
      this.toastr.error(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    }
  }
  ngOnInit() {
    this.ngOnInitAsync()
  }

  async ngOnInitAsync(): Promise<void> {
    try {
      const currentPeriod = parseInt(new Date().toISOString().substring(0, 10).substring(0, 7).replace("-", ""));
      this.transactions = await this.db.getTransactionListAsync('first', currentPeriod, this.auth.currentUserIDSig().uid);
      this.totals = await this.db.getTotalsAsync(this.auth.currentUserIDSig().uid);
      this.paginationSize = this.db.paginationSize;
      this.firstPage = true;
      if (this.transactions.length < this.paginationSize) {
        this.lastPage = true
      }
      this.showSpinner = false;
      this.catsArray = await this.db.getCatsAsync(this.auth.currentUserIDSig().uid);
      await this.listOfPeriods()
    } catch (err) {
      console.log(err.code)
    }
  }

  async listOfPeriods(): Promise<void> {
    try {
      const periods = await this.db.getPeriodsAsync(this.auth.currentUserIDSig().uid);
      for (const period of periods) {
        this.periodsArray.push(period.content['periodID']);
      }
      this.periodsArray.sort().reverse()
      this.periodsToDisplay = this.periodsArray.slice(0, 3)
      this.selectedPeriod = this.periodsToDisplay[0]
      this.currentPeriod = this.periodsToDisplay[0]
      this.db.periodsSig.set(periods)
    } catch (err) {
      console.log('Error fetching periods:', err)
    }
  }

  async searchTransactions(column: string, phrase: string): Promise<void> {
    try {
      column = column[0].toUpperCase() + column.slice(1);
      this.transactions = await this.db.getTransactionListMatchingPhraseAsync(column, phrase, this.auth.currentUserIDSig().uid);
      this.searchFlag = true;
    } catch (err) {
      console.log(err.code)
    }
  }

  async clearSearch() {
    try {
      this.transactions = await this.db.getTransactionListAsync('first', this.currentPeriod, this.auth.currentUserIDSig().uid);
      this.searchFlag = false;
      this.searchPhraseModel = { phrase: '' }
      this.searchPanel = false;
    } catch (err) {
      console.log(err.code)
    }
  }

  async getNextTransactions() {
    try {
      const nextDocs = await this.db.getTransactionListAsync('next', this.selectedPeriod, this.auth.currentUserIDSig().uid);
      let counter = 0;
      for (const doc of nextDocs) {
        counter++;
        this.transactions.push(doc);
      }
      if (counter < this.paginationSize) {
        this.lastPage = true;
      }
      this.firstPage = false;
    } catch (err) {
      console.log(err.code)
    }
  }

  async deleteTransaction(docID: string, index: number): Promise<void> {
    // const transPeriod = parseInt(this.selectedTrans['Date'].substring(0, 7).replace("-", ""));
    // const transAmount = this.selectedTrans['Amount'];
    // const transCatID = this.selectedTrans['catID'];
    // const period: number = parseInt(this.selectedTrans['Date'].substring(0, 7).replace("-", ""))
    // let periodDocID: string;
    try {
      await this.db.deleteTransactionAsync(docID, this.auth.currentUserIDSig().uid);
      // await this.db.setTotalsAsync('subtract', this.auth.currentUserIDSig().uid)
      // this.totals = await this.db.getTotalsAsync(this.auth.currentUserIDSig().uid)
      if (docID === this.transactions[index]._id) {
        this.transactions.splice(index, 1);
      }
      if (this.transactions.length === 0) {
        this.transactions = await this.db.getTransactionListAsync('first', this.selectedPeriod, this.auth.currentUserIDSig().uid)
      }
      // for (const inter of Object.keys(this.db.periodsSig())) {
      //   for (const outer of Object.keys(this.db.periodsSig()[inter])) {
      //     if (this.db.periodsSig()[inter][outer].periodID === period) {
      //       periodDocID = this.db.periodsSig()[inter].id;
      //       await this.db.updateExpenseInPeriodsAsync(-1, -transAmount, periodDocID, this.auth.currentUserIDSig().uid);
      //     }
      //   }
      // }
      // await this.db.updateExpenseInCategoriesAsync(transPeriod, -transAmount, transCatID, this.auth.currentUserIDSig().uid);
      this.showToast('success', `${this.translocoService.translate('toasts.transactionsSuccessMessageParamDelTransaction', { transID: this.selectedTrans['ID'] }, this.auth.currentUserSig()?.lang)}`)
    } catch (err) {
      console.log(err)
      this.showToast('error', `${this.translocoService.translate('toasts.transactionsFailMessageParamDelTransaction', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }


  updatePeriodsToDisplay(command: string) {
    const noOfPeriods = this.periodsArray.length
    const maxIndex = noOfPeriods - 3
    if (command == 'prev') {
      this.periodsToDisplayIndex--;
      if (this.periodsToDisplayIndex == 0) {
        this.periodDisplay = 'start'
      }
    }
    else if (command == 'next') {
      this.periodDisplay = 'middle'
      this.periodsToDisplayIndex++;
      if (this.periodsToDisplayIndex == maxIndex) {
        this.periodDisplay = 'end'
      }
    }
    else if (command == 'reset') {
      this.periodDisplay = 'start'
      this.periodsToDisplayIndex = 0;
    }
    this.periodsToDisplay = this.periodsArray.slice(this.periodsToDisplayIndex, this.periodsToDisplayIndex + 3)
  }

  async selectPeriod(period: number): Promise<void> {
    this.selectedPeriod = period;
    try {
      const transactions = await this.db.getTransactionListAsync('first', period, this.auth.currentUserIDSig().uid);
      this.firstPage = true;
      this.lastPage = false;
      if (transactions.length < this.paginationSize) {
        this.lastPage = true;
      }
      this.transactions = transactions;
    } catch (err) {
      console.log(err.code)
    }
  }

  selectSearchField(option: string) {
    this.searchColumn = option;
  }

  toggleTransactionsView(currentView: string) {
    if (currentView == 'grid') {
      this.transactionsView = 'table'
    } else {
      this.transactionsView = 'grid'
    }
  }
  toggleSearch() {
    this.searchPanel = !this.searchPanel
  }

  appendFilterObject(property: string, value: string) {
    if (property === 'category') {
      this.searchObject['category'] = value;
    }
    if (property === 'period') {
      this.searchObject['period'] = value;
    }
    if (property === 'amountFrom') {
      this.searchObject['amountFrom'] = value;
    }
    if (property === 'amountTo') {
      this.searchObject['amountTo'] = value;
    }
  }

  isDuplicate(transID: number): boolean {
    // sprawdza w danym okresie i danej paginacji (powinno byc ok z wyjątkiem 100 transakcji z tego samego dnia)
    const objects = this.transactions;
    const obj = objects.find(o => o.ID === transID);
    if (!obj) return false;
    if (obj.hash ===undefined) return false;

    return objects.some(o =>
      o.ID !== transID && o.hash === obj.hash
    );
  }

}
